/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/VideoTeaser/theme';

export const VideoTeaserTheme = theme;
